export enum permissionStatus {
  enabled = "enabled",
  disabled = "disabled",
}
